import { Handle, Position } from '@xyflow/react'
import armLogo from '@/assets/panneau-solaire.png'

function SolarPanelNode({ data, isConnectable }) {
  return (
    <div className="custom-node-robots robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={armLogo} alt="Solar Panel Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Solar Panel</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default SolarPanelNode
